// extracted by mini-css-extract-plugin
export default {"container":"LoginForm_container__LKqXT","form":"LoginForm_form__EpSU9","submitForm":"LoginForm_submitForm__WhaJA"};